export const WarehousesColumns = [
    {
        name: '№',
        key: 'id',
    },
    {
        name: 'Город',
        key: 'cityName',
    },
    {
        name: 'Название склада',
        key: 'titleRu',
    },
    {
        name: 'Ответственное лицо',
        key: 'fullNameRu',
    },
    {
        name: 'Полный адрес',
        key: 'fullAddressRu',
    },
    {
        name: 'Телефон',
        key: 'phone',
    },
    {
        name: 'email',
        key: 'email',
    },
    {
        name: 'Широта',
        key: 'latitude',
    },
    {
        name: 'Долгота',
        key: 'longitude',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
]
